class TrProductMediaPagination extends HTMLElement {
	selectors = {
		button: '[data-tr-js-product-media-pagination-button]',
		slider: '[id^="Slider-"]',
		slide: '[id^="Slide-"]',
	};

	attributes = {
		index: 'data-tr-js-product-media-pagination-index',
	};

	stateClasses = {
		isActive: 'is-active',
	};

	connectedCallback() {
		this.sliderComponentElement = this.closest('slider-component');
		this.sliderElement = this.sliderComponentElement?.querySelector(
			this.selectors.slider,
		);
		this.slideElements = [
			...(this.sliderComponentElement?.querySelectorAll(this.selectors.slide) ??
				[]),
		];
		this.buttonElements = [...this.querySelectorAll(this.selectors.button)];

		this.init();
		this.bindEvents();

		document.addEventListener('shopify:section:load', this.onSectionLoad);
		document.addEventListener('shopify:block:select', this.onBlockSelect);
	}

	disconnectedCallback() {
		document.removeEventListener('shopify:section:load', this.onSectionLoad);
		document.removeEventListener('shopify:block:select', this.onBlockSelect);

		this.destroy();
	}

	init() {
		const currentPage = this.sliderComponentElement?.currentPage ?? 1;

		this.updateActiveButton(currentPage - 1);
	}

	bindEvents() {
		this.sliderComponentElement?.addEventListener(
			'slideChanged',
			this.onSlideChange,
		);

		this.buttonElements.forEach(buttonElement => {
			buttonElement.addEventListener('click', this.onPaginationButtonClick);
		});
	}

	onSectionLoad = event => {
		if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;

		this.init();
	};

	onBlockSelect = event => {
		if (!this.closest(`#shopify-section-${event.detail.sectionId}`)) return;

		this.init();
	};

	onSlideChange = event => {
		this.updateActiveButton(event.detail.currentPage - 1);
	};

	onPaginationButtonClick = event => {
		const selectedIndex = Number(
			event.currentTarget.getAttribute(this.attributes.index),
		);
		const selectedSlideElement = this.slideElements[selectedIndex];

		if (
			!selectedSlideElement ||
			!this.sliderElement ||
			typeof this.sliderComponentElement?.setSlidePosition !== 'function'
		)
			return;

		this.sliderComponentElement.setSlidePosition(selectedSlideElement.offsetLeft);
	};

	updateActiveButton(selectedIndex) {
		this.buttonElements.forEach((buttonElement, buttonIndex) => {
			const isActive = buttonIndex === selectedIndex;

			buttonElement.classList.toggle(this.stateClasses.isActive, isActive);

			if (isActive) {
				buttonElement.setAttribute('aria-current', 'true');
				return;
			}

			buttonElement.removeAttribute('aria-current');
		});
	}

	destroy() {
		this.sliderComponentElement?.removeEventListener(
			'slideChanged',
			this.onSlideChange,
		);

		this.buttonElements.forEach(buttonElement => {
			buttonElement.removeEventListener(
				'click',
				this.onPaginationButtonClick,
			);
		});

		this.buttonElements = [];
		this.slideElements = [];
		this.sliderElement = null;
		this.sliderComponentElement = null;
	}
}

if (!customElements.get('tr-product-media-pagination')) {
	customElements.define(
		'tr-product-media-pagination',
		TrProductMediaPagination,
	);
}
